import _ from "@lodash";
import { withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import ConfirmacaoApp from "app/Core/Components/Confirmacao/ConfirmacaoApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import MobileDetect from "mobile-detect";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import GerenciadorProcessoDialog from "./GerenciadorProcessoDialog";
import * as Actions from "./Store/Actions/GerenciadorProcessoActions";
import GerenciadorProcessoReducer from "./Store/Reducers/GerenciadorProcessoReducer";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    button: {
        backgroundColor: theme.palette.primary.main,
    },
});

const NewState = {
    open: null,
    observacao: null,
    prazo: null,
    termino: null,
    data: null,
    horario: null,
};

class GerenciadorProcessoApp extends XAPPComponent {

    state = { ...NewState };

    componentDidMount() {
        const { playAuto, Tarefa } = this.props;
        this.setState(NewState);

        if (!_.isUndefined(playAuto) && !_.isUndefined(Tarefa) && !_.isNull(Tarefa.idfluxo)) {
            var AAction = _.find(Tarefa.jsonpasso.actions, { idfluxopassoacao: Tarefa });
            this.fireAction(AAction, this.props, this.state);
        }
    }

    componentDidUpdate() {
        if (this.props.reducer.error) {
            this.props.showMessage({
                message: this.props.reducer.error,
                variant: "error"
            });
            this.props.reducer.error = null;
        }
        if (this.props.reducer.warning) {
            this.props.showMessage({
                message: this.props.reducer.warning,
                variant: "warning"
            });
            this.props.reducer.warning = null;
        }
        if (this.props.reducer.info) {
            this.props.showMessage({
                message: this.props.reducer.info,
                variant: "success"
            });
            this.props.reducer.info = null;
        }
    }

    openDialog = (_AValue) => {
        this.setState({ "open": _AValue });
    };

    canBeSubmitted = (_AVerificar) => {
        var AResponse = true;

        if (_AVerificar) {
            AResponse = this.props.canBeSubmitted();
        }
        return AResponse;
    };

    async fireAction(_AItem, _AProps) {
        var xappRouteParams;
        var Tarefa;
        var close;
        var getNext;
        var acao;

        if (this === undefined) {
            xappRouteParams = _AProps.xappRouteParams;
            Tarefa = _AProps.Tarefa;
            close = _AProps.close;
            getNext = _AProps.getNext;
            acao = _AProps.acao;
        }
        else {
            xappRouteParams = this.props.xappRouteParams;
            Tarefa = this.props.Tarefa;
            close = this.props.close;
            getNext = this.props.getNext;
            acao = this.props.acao;
        }
        acao(Tarefa, xappRouteParams, _AItem, close, getNext);
    }

    render() {
        const { Tarefa = null, passofluxo, xappRouteParams, classes, canBeClose = null, getNext, close } = this.props;
        var groupList = null;

        groupList = Tarefa !== null && Tarefa.jsonpasso.actions.map((item) => {
            if (item.proximopasso === 666) {
                return (
                    <XAPPButton
                        key={item.nome + "_button"}
                        type="Button"
                        color="primary"
                        className={clsx(classes.button, " min-w-60 pl-6 pr-6 pt-14 pb-14")}
                        variant="contained"
                        onClick={() => this.openDialog(item)}
                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                        icon={item.icone}
                        label={md.mobile() === null && md.tablet() === null ? item.nome : ""}
                        disabled={!this.canBeSubmitted(item.checkrequeridos)}
                    />
                );
            }
            else if (item.skipconfirmacao) {
                return (
                    <XAPPButton
                        key={item.nome + "_button"}
                        id={item.nome + "_button"}
                        type="button"
                        color="primary"
                        variant="contained"
                        disabled={!this.canBeSubmitted(item.checkrequeridos)}
                        onClick={() => this.fireAction(item, this.props, this.state)}
                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                        icon={item.icone}
                        label={md.mobile() === null && md.tablet() === null ? item.nome : ""}
                        className={clsx(classes.button, " min-w-60 pl-6 pr-6 pt-14 pb-14")}
                    />
                );
            }
            else {
                return (
                    <ConfirmacaoApp
                        key={item.nome + "_confirmation"}
                        id={item.nome + "_confirmation"}
                        data=""
                        type="button"
                        color="primary"
                        variant="contained"
                        disabled={!this.canBeSubmitted(item.checkrequeridos)}
                        onConfirmation={() => this.fireAction(item, this.props, this.state)}
                        tipoAcao={!_.isNull(canBeClose) && canBeClose.tipo}
                        mensagem={!_.isNull(canBeClose) ? canBeClose.mensagem : "Tem certeza que deseja executar a ação \"" + item.nome + "\"?"}
                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                        icon={item.icone}
                        label={md.mobile() === null && md.tablet() === null ? item.nome : ""}
                        className={clsx(classes.button, " min-w-60 pl-6 pr-6 pt-14 pb-14")}
                    />
                );
            }
        });

        return (
            <React.Fragment>
                <CatchErro
                //url={this.props.match.url}
                >
                    {groupList}
                    <GerenciadorProcessoDialog
                        open={this.state.open}
                        openDialog={this.openDialog}
                        Tarefa={Tarefa}
                        passofluxo={passofluxo}
                        xappRouteParams={xappRouteParams}
                        fireAction={this.fireAction}
                        close={close}
                        getNext={getNext}
                    />
                </CatchErro>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        acao: Actions.acao,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ GerenciadorProcessoApp, auth }) {
    return {
        reducer: GerenciadorProcessoApp,
        user: auth.user.data
    };
}

export default withStyles(styles, { withTheme: true })(withReducer("GerenciadorProcessoApp", GerenciadorProcessoReducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(GerenciadorProcessoApp))));

